module.exports = __webpack_public_path__ + "static/aurelie-59df7400a7c25c9b91a8cee1aadd566e.jpg";